var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.52599 1.4701C0.265641 1.20975 0.265641 0.787643 0.52599 0.527293C0.78634 0.266944 1.20845 0.266944 1.4688 0.527293L5.4688 4.52729C5.72119 4.77968 5.73002 5.18607 5.48883 5.44918L1.82216 9.44918C1.57337 9.72059 1.15166 9.73893 0.880245 9.49013C0.608832 9.24134 0.590497 8.81963 0.839292 8.54822L4.07464 5.01875L0.52599 1.4701Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.0a5f8b304facb70d60374cca41891979.svg";
export { ForwardRef as ReactComponent };